module.exports = "/static/media/pdc-logo.7bb4fe18.svg";